<template>
    <div class="card-challenge-result-stat-win-loss">
        <div class="card-challenge-result-stat-win-loss__win">
            <div class="card-challenge-result-stat-win-loss__win-label">KAZANMA</div>
            <div class="wr-card-challenge-result-stat-win-loss__win-value">
                <span class="card-challenge-result-stat-win-loss__win-icon"></span>
                <span class="card-challenge-result-stat-win-loss__win-value">{{ statWin }}</span>
                <span
                    v-if="showChangeWin"
                    class="card-challenge-result-stat-win-loss__change">+1</span>
            </div>
        </div>

        <div class="card-challenge-reslt-stat-win-loss__loss">
            <div class="card-challenge-result-stat-win-loss__loss-label">KAYBETME</div>
            <div class="wr-card-challenge-result-stat-win-loss__loss-value">
                <span class="card-challenge-result-stat-win-loss__loss-icon"></span>
                <span class="card-challenge-result-stat-win-loss__loss-value">{{ statLoss }}</span>
                <span
                    v-if="showChangeLoss"
                    class="card-challenge-result-stat-win-loss__change">+1</span>
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            resultItem: {
                type: Object,
                default: {
                    id: 9,
                    status: "COMPLETED",
                    user1: {
                        id: 1,
                        username: "temren",
                        status: "DONE-PRACTICE"
                    },
                    user2: {
                        id: 2,
                        username: "kral1790",
                        status: "DONE-PRACTICE"
                    },
                    results: {
                        draw: false,
                        user1: "winner",
                        user2: "loser"
                    },
                    stats: {
                        correctness: {
                            user1: 40,
                            user2: 10
                        },
                        correct: {
                            user1: 15,
                            user2: 12
                        },
                        incorrect: {
                            user1: 3,
                            user2: 7
                        },
                        skipped: {
                            user1: 2,
                            user2: 1
                        },
                        win: {
                            user1: 19,
                            user2: 10
                        },
                        loss: {
                            user1: 19,
                            user2: 5
                        }
                    }
                }
            },
        },

        computed: {
            statWin(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                return this.resultItem.stats.win[curUserType];
            },

            statLoss(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                return this.resultItem.stats.loss[curUserType];
            },

            showChangeWin(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                return this.resultItem.results[curUserType] === 'winner'
                       ? true
                       : false;
            },

            showChangeLoss(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                return this.resultItem.results[curUserType] === 'loser'
                       ? true
                       : false;
            }
        },
    };
</script>

<style scoped src="@/css/components/card-challenge-result-stat-win-loss.css"></style>